import { AlertTriangle } from '@gympass/yoga-icons';
import { useIntl } from 'react-intl';

import { InvoiceBannerProps } from './types';

import * as S from './styles';

const InvoiceBanner: React.FC<InvoiceBannerProps> = ({ pendingMonth = 0 }) => {
  const intl = useIntl();

  const monthsArray = [
    'JANUARY',
    'FEBRUARY',
    'MARCH',
    'APRIL',
    'MAY',
    'JUNE',
    'JULY',
    'AUGUST',
    'SEPTEMBER',
    'OCTOBER',
    'NOVEMBER',
    'DECEMBER',
  ];

  const pendingMonthTranslation = intl.formatMessage({
    id: `MONTHLIST.${
      pendingMonth === 12 ? monthsArray[0] : monthsArray[pendingMonth]
    }`,
  });

  const message = intl.formatMessage(
    {
      id: 'CPPAYMENTS.BANNER.RECEIPTINFORMATION',
    },
    {
      b: chunks => (<S.Span>{chunks}</S.Span>) as any,
      month: pendingMonthTranslation || '',
    },
  );

  if (pendingMonth > 12) {
    return <></>;
  }

  return (
    <S.InvoiceBanner
      message={message}
      variant="attention"
      icon={AlertTriangle}
    />
  );
};

export default InvoiceBanner;
